"use strict";
exports.__esModule = true;
var EventHandler = /** @class */ (function () {
    function EventHandler() {
        this.events = [];
    }
    // According to MDN, "If not specified, useCapture defaults to false.",
    // so we'll follow suit and set the default value of the `options`/`useCapture` parameter to `false`.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#parameters
    EventHandler.prototype.register = function (el, event, listener, options) {
        if (options === void 0) { options = false; }
        if (!el || !event || !listener)
            return null;
        this.events.push({ el: el, event: event, listener: listener, options: options });
        el.addEventListener(event, listener, options);
        return { el: el, event: event, listener: listener, options: options };
    };
    EventHandler.prototype.unregister = function (eventObject) {
        if (!eventObject)
            return null;
        var el = eventObject.el, event = eventObject.event, listener = eventObject.listener, options = eventObject.options;
        if (!el || !event || !listener)
            return null;
        var indexToRemoveFrom = this.events.findIndex(function (e) { return (e.event === event && e.listener === listener && e.options === options); });
        if (indexToRemoveFrom === -1)
            return null;
        this.events.splice(indexToRemoveFrom, 1);
        el.removeEventListener(event, listener, options);
        return eventObject;
    };
    EventHandler.prototype.unregisterAll = function () {
        this.events.forEach(function (_a) {
            var el = _a.el, event = _a.event, listener = _a.listener, options = _a.options;
            return el.removeEventListener(event, listener, options);
        });
        this.events = [];
    };
    return EventHandler;
}());
exports["default"] = EventHandler;
